module.exports = __webpack_public_path__ + "fonts/Flaticon.svg?07fc841dd4f25c9c9612d71b5a46da85";